import { render, staticRenderFns } from "./InspirationCompanyBadge.vue?vue&type=template&id=36332cc5"
import script from "./InspirationCompanyBadge.vue?vue&type=script&lang=ts"
export * from "./InspirationCompanyBadge.vue?vue&type=script&lang=ts"
import style0 from "./InspirationCompanyBadge.vue?vue&type=style&index=0&id=36332cc5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports